/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {AfterContentChecked, AfterViewChecked, Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {WizardStepComponent} from '../../../shared/wizard/wizard-step.component';
import {WizardService} from '../../../shared/wizard/wizard.service';
import {WizardStepModel} from '../../../shared/wizard/wizard-step.model';
import {Subscription} from 'rxjs';
import {MaterialListService} from '../../../shared/material-list/service/material-list.service';
import {MaterialValidateResultModel} from '../../../api/ms-specialorders/contracts/material-validate-result.model';
import {WizardIconEnum} from '../../../shared/wizard/wizard-icon.enum';
import {SpecialOrderMaterialDetailModel} from '../../../api/ms-specialorders/contracts/special-order-material-detail.model';

@Component({
    selector: 'app-step-confirm-send',
    templateUrl: './step-confirm-send.component.html',
    styleUrls: ['./step-confirm-send.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StepConfirmSendComponent extends WizardStepComponent implements OnInit, OnDestroy, AfterContentChecked, AfterViewChecked {

    @Input() stepIndex: number;
    stepModel = {
        canSave: true,
        canSend: true,
        data: [],
        icon: WizardIconEnum.NONE,
    } as WizardStepModel;

    private invalidMaterials: string[] = [];

    private subscriptions = new Subscription();

    constructor(private service: WizardService, private materialListService: MaterialListService) {
        super(service);
    }

    get headerStep(): WizardStepModel {
        return this.service.steps.get(0);
    }

    get materialListStep(): WizardStepModel {
        return this.service.steps.get(1);
    }

    get filteredMaterialList(): WizardStepModel {
        if (this.invalidMaterials.length > 0) {
            this.service.steps.get(2).data = this.service.steps.get(1).data.filter((material: SpecialOrderMaterialDetailModel) =>
                    !this.invalidMaterials.includes(material.material.number));
        } else {
            this.service.steps.get(2).data = this.service.steps.get(1).data;
        }
        return this.service.steps.get(2);

    }

    ngAfterContentChecked(): void {
        this.sendUpdateForm();
    }

    ngAfterViewChecked(): void {
        this.sendUpdateForm();
    }

    ngOnInit(): void {
        super.ngOnInit();

        this.subscriptions.add(
                this.materialListService.invalidMaterials.subscribe((invalidMaterials: MaterialValidateResultModel) => {
                    this.invalidMaterials = invalidMaterials.materialNumbers;
                }));

        setTimeout(() => {
            this.subscriptions.add(this.service.observable.subscribe(() => {
                this.stepModel.canSend = this.headerStep.canSend && this.materialListStep.canSend;

                if ([this.headerStep.icon, this.materialListStep.icon].includes(WizardIconEnum.ERROR)) {
                    this.stepModel.icon = WizardIconEnum.ERROR;
                } else if ([this.headerStep.icon, this.materialListStep.icon].includes(WizardIconEnum.WARNING)) {
                    this.stepModel.icon = WizardIconEnum.WARNING;
                } else {
                    this.stepModel.icon = WizardIconEnum.SUCCESS;
                }
            }));
        });
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
